<template>
  <v-card
    class="ident-detail-card"
    color="grey lighten-2"
    flat
  >
    <!-- IDENT DETAILS START -->
    <v-card>
      <v-card-title class="toolbar primary white--text title">
        <v-icon
          dark
          color="white"
          class="mr-2"
        >
          assignment
        </v-icon>
        Ident detail: {{ getProviderName(ident.provider) }}
      </v-card-title>
      <v-card-text>
        <v-layout
          wrap
          class="pa-0 "
          :class="
            ident.hasValidDocs === true ? 'success lighten-5' : (
              ident.state === 'success' ? 'orange lighten-5' : 'grey lighten-4'
            )"
        >
          <v-flex
            v-for="item in filterIdentItems(ident)"
            :key="item.text"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-text-field
                    :label="item.text"
                    :value="ident[item.value]"
                    readonly
                  />
                </span>
              </template>
              <span>
                field: {{ item.value }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!-- IDENT DETAILS END -->

      <!-- PROVIDER CASES TABLE START -->
      <v-card-title
        v-if="ident.cases && ident.cases.data.length > 0"
        class="toolbar grey lighten-4 title"
      >
        {{ ident.provider }} cases
      </v-card-title>
      <v-data-table
        v-if="ident.cases && ident.cases.data.length > 0"
        :headers="getObjectHeaders(ident.cases.data[0])"
        :items="ident.cases.data"
        hide-actions
      >
        <template
          slot="headerCell"
          slot-scope="props"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.value }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          <tr>
            <td
              v-for="(item,key) in props.item"
              :key="key"
            >
              {{ item ? item : '---' }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- PROVIDER CASES TABLE END -->
    </v-card>
    <v-card class="mt-5">
      <!-- USER DETAILS START -->
      <v-card-title class="toolbar primary white--text title">
        <v-icon
          dark
          color="white"
          class="mr-2"
        >
          {{ ident.state === 'success' ? 'assignment_turned_in' : 'assignment_ind' }}
        </v-icon>
        User ident details
        <v-spacer />

        <!-- DOWNLOAD BUTTON -->
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              class="downloadIdentificationFiles"
              dark
              flat
              :loading="isLoadingUserFiles"
              v-on="on"
              @click.stop="downloadIdentificationFiles"
            >
              <v-icon class="mr-2">
                cloud_download
              </v-icon> Download
            </v-btn>
          </template>
          <span>Download user identification files</span>
        </v-tooltip>
        <!-- DOWNLOAD BUTTON -->
      </v-card-title>
      <v-progress-linear
        v-if="isLoadingUserDetail"
        :indeterminate="true"
        class="ma-0"
      />
      <!-- START USER IDENT DETAILS -->

      <v-card-text v-if="userIdentDetail">
        <v-layout
          dark
          wrap
          class="pa-0 "
          :class="
            userIdentDetail.hasValidDocs === true ? 'success lighten-5' : (
              userIdentDetail.identified === 'success' ? 'orange lighten-5' : 'grey lighten-4'
            )"
        >
          <v-flex
            v-for="item in getObjectHeaders(userIdentDetail)"
            :key="item.text"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-text-field
                    :label="item.text"
                    :value="userIdentDetail[item.value]"
                    readonly
                  />
                </span>
              </template>
              <span>
                field: {{ item.value }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!-- END USER IDENT DETAILS -->

      <!-- START USER DETAILS -->
      <v-card-text v-if="userDetail">
        <v-layout
          wrap
          class="pa-0"
        >
          <v-flex
            v-for="user in filterUserItems(userDetail)"
            :key="user.text"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-text-field
                    :label="user.text"
                    :value="userDetail[user.value]"
                    readonly
                  />
                </span>
              </template>
              <span>
                field: {{ user.value }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!-- END USER DETAILS -->
      <v-alert
        v-if="error"
        :value="error"
        type="error"
        color="error"
      >
        {{ error }}
      </v-alert>
      <!-- USER DETAILS END -->
    </v-card>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { identProviders, identStatus } from '@/enum/ident/IdentEnum';

export default {
  name: 'IdentDetailCard',
  props: {
    ident: {
      type: Object,
      required: true,
    },
    getUserIdentificationFiles: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      identProviders,
      identStatus,
      isLoadingUserDetail: false,
      isLoadingUserFiles: false,
      userDetail: null,
      userIdentDetail: null,
      error: null,
    };
  },
  computed: {
    identCase() {
      return this.$store.state.identStore.identDetail;
    },
    idents() {
      return this.identCase.cases.data;
    },
    identStatuses() {
      return Object.keys(this.identStatus).map(item => this.identStatus[item]);
    },
    providers() {
      return Object.keys(this.identProviders).map(item => this.identProviders[item]);
    },
  },
  mounted() {
    this.getUserIdentDetails();
  },
  methods: {
    filterIdentItems(ident) {
      return this.getObjectHeaders(ident).filter(item => this.canShowIdentField(item)).sort();
    },
    filterUserItems(ident) {
      return this.getObjectHeaders(ident).filter(item => this.canShowUserField(item)).sort();
    },
    getObjectHeaders(ident) {
      const identFields = { ...ident };
      delete identFields.cases;

      return Object.keys(identFields)
        .map(key => ({ text: _.startCase(key), value: key, sortable: false }));
    },
    canShowIdentField(item) {
      const fieldsToHide = [
        'userId',
        'provider',
      ];

      return !!this.ident[item.value] && !fieldsToHide.includes(item.value);
    },
    canShowUserField(item) {
      const fieldsToShow = [
        'address',
        'citizenship',
        'city',
        'country',
        'country_of_birth',
        'email',
        'first_name',
        'last_name',
        'legitimation_document',
        'marital_status',
        'pass',
        'pass_authority',
        'pass_country_of_issue',
        'pass_created_at',
        'pass_expires_at',
        'phone',
        'postal_code',
        'sex',
        'street',
        'street_no',
        'tax_id'];

      return !!this.userDetail[item.value] && fieldsToShow.includes(item.value);
    },
    getProviderName(value) {
      let providerName = '';

      Object.keys(this.identProviders)
        .forEach((item) => {
          if (this.identProviders[item].value === value) {
            providerName = this.identProviders[item].title;
          }

          return item;
        });

      return providerName;
    },
    getUserIdentDetails() {
      this.isLoadingUserDetail = true;
      this.$store.dispatch('fetchUserDetails', this.ident.userId)
        .then(({ identData, userData }) => {
          this.userIdentDetail = identData;
          this.userDetail = userData;
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.isLoadingUserDetail = false;
        });
    },
    downloadIdentificationFiles() {
      this.isLoadingUserFiles = true;

      const postData = {
        id: this.ident.userId,
        identType: this.ident.provider.toLowerCase(),
      };
      this.getUserIdentificationFiles(postData)
        .finally(() => {
          this.isLoadingUserFiles = false;
        });
    },
  },
};
</script>
<style lang="scss">
.ident-detail-card {
  padding: 32px;
  .v-card__title {
    padding: 16px 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ident/IdentDetailCard.vue